import { Link, useLocation } from 'react-router';

import { tituloDeRuta } from '@/app/navegacion';
import { PermissionGate } from '@/auth/PermissionGate';
import { AVATARES } from '@/lib/avatares';

/**
 * Rutas del plan §13.4 que todavía no se migran (Fases 5–9). Respetan el permiso igual que
 * la vista final, así que el alumno ve lo mismo que verá cuando el módulo esté listo.
 */
export function ModuloPage({ permiso }: { permiso?: string }) {
  const { pathname } = useLocation();
  const titulo = tituloDeRuta(pathname);
  return (
    <PermissionGate permiso={permiso} modulo={titulo}>
      <section className="panel-vidrio mx-auto max-w-2xl text-center">
        <img src={AVATARES.doctoraSenala} alt="" className="mx-auto h-32 w-auto" />
        <h1 className="mt-3 text-2xl font-extrabold text-azul-texto">{titulo}</h1>
        <div aria-hidden className="mx-auto mt-1 h-[3px] w-40 rounded-full bg-verde-500" />
        <p className="mt-3 text-texto-2">
          Estamos trayendo este módulo a la nueva plataforma. Muy pronto podrás usarlo aquí.
        </p>
        <Link to="/inicio" className="btn-cs btn-contorno mt-6">
          Volver al inicio
        </Link>
      </section>
    </PermissionGate>
  );
}

export function NoEncontradaPage() {
  return (
    <section className="panel-vidrio mx-auto mt-10 max-w-xl text-center">
      <img src={AVATARES.doctor} alt="" className="mx-auto h-32 w-auto" />
      <p className="mt-2 text-5xl font-extrabold text-cian-texto">404</p>
      <h1 className="mt-2 text-xl font-extrabold text-texto">No encontramos esta página</h1>
      <p className="mt-2 text-texto-2">Revisa la dirección o vuelve al inicio.</p>
      <Link to="/inicio" className="btn-cs btn-primario mt-6">
        Ir al inicio
      </Link>
    </section>
  );
}
